import { Controller } from "@hotwired/stimulus"

// Store checkout address (TMS-1548): the state field follows the country. The US and Canada
// get their own lists; anywhere else gets a free-text "State / Region". Only the visible field
// is enabled, so only it is submitted.
export default class extends Controller {
  static targets = ["country", "stateList", "stateText"]

  connect() {
    this.countryInput = this.countryTarget.querySelector("[data-app-select-target=\"hidden\"][name]")
    this.onCountryChange = () => this.sync()
    this.countryInput?.addEventListener("app-select:change", this.onCountryChange)
  }

  disconnect() {
    this.countryInput?.removeEventListener("app-select:change", this.onCountryChange)
  }

  sync() {
    const country = (this.countryInput?.value || "").toUpperCase()
    let listShown = false
    this.stateListTargets.forEach((group) => {
      const show = group.dataset.country === country
      listShown ||= show
      this.toggle(group, show)
    })
    this.toggle(this.stateTextTarget, !listShown)
  }

  toggle(group, show) {
    group.hidden = !show
    group.querySelectorAll("input, button, select").forEach((element) => { element.disabled = !show })
  }
}
